import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import axios from "../../../lib/axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { ICoshhSubstance, ICoshhSubstanceCreatePayload, ICoshhSubstanceUpdatePayload } from "../../../types/api/coshh";

export const useCoshhList = (initialParams: any = {}) => {
  const [params, setParams] = useState(initialParams);
  const result = useQuery({
    queryKey: [API_ENDPOINTS.COSHH_LIST, { ...params, total: null }],
    queryFn: async () => {
      const res = await axios.get(API_ENDPOINTS.COSHH_LIST, { params });
      return res.data;
    },
    select: (res: any) => ({
      ...res,
      data: (res.data || []).map((x: ICoshhSubstance) => ({ key: x.id, ...x })),
      qData: { ...params, total: res.extra?.total },
    }),
    initialData: { data: [], success: true, message: "", code: 200, qData: {}, extra: { page: 1, limit: 20, total: 0 } },
    staleTime: 20000,
    initialDataUpdatedAt: 0,
    refetchOnWindowFocus: false,
  });
  return { ...result, refetchWithQuery: (p: any) => setParams((prev: any) => ({ ...prev, ...p })) };
};

export const useCoshhCreate = (options?: { onSuccess?: () => void; onError?: (e: any) => void }) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (data: ICoshhSubstanceCreatePayload) => {
      const res = await axios.post(API_ENDPOINTS.COSHH_CREATE, data);
      return res.data;
    },
    onSuccess: () => { qc.invalidateQueries({ queryKey: [API_ENDPOINTS.COSHH_LIST] }); options?.onSuccess?.(); },
    onError: options?.onError,
  });
};

export const useCoshhUpdate = (options?: { onSuccess?: () => void; onError?: (e: any) => void }) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (data: ICoshhSubstanceUpdatePayload) => {
      const res = await axios.post(API_ENDPOINTS.COSHH_UPDATE, data);
      return res.data;
    },
    onSuccess: () => { qc.invalidateQueries({ queryKey: [API_ENDPOINTS.COSHH_LIST] }); options?.onSuccess?.(); },
    onError: options?.onError,
  });
};

export const useCoshhDelete = (options?: { onSuccess?: () => void; onError?: (e: any) => void }) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: number) => {
      const res = await axios.post(API_ENDPOINTS.COSHH_DELETE, { id });
      return res.data;
    },
    onSuccess: () => { qc.invalidateQueries({ queryKey: [API_ENDPOINTS.COSHH_LIST] }); options?.onSuccess?.(); },
    onError: options?.onError,
  });
};
